import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';
import type { NavigationKey } from '@/i18n/keys';

const section = (path: string, titleKey: NavigationKey): RouteObject => ({
  path,
  handle: handle(titleKey),
  lazy: () => import('./SectionPage').then((m) => ({ Component: m.SectionPage })),
});
/** Routes for nav items whose screens are still on the migration backlog. */
export const sectionRoutes: RouteObject[] = [
  section('construction-projects', 'constructionProjects'),
  section('ewr', 'emergencyWorkRequests'),
  section('meetings', 'meetings'),
  section('news', 'news'),
  section('resources-and-tools', 'resourcesAndTools'),
  {
    path: 'enforcement',
    children: [
      section('stop-work-orders', 'stopWorkOrders'),
      section('notices-of-infraction', 'noticesOfInfraction'),
    ],
  },
  section('about-us', 'aboutUs'),
  section('contact-us', 'contactUs'),
];
